import { useMutation } from '@tanstack/react-query';

import { Workspaces } from '@air/api';
import { reportErrorToBugsnag } from '@air/utils-error';

import { type BoardTemplate } from '~/components/Modals/BoardTemplateModal/types';

export type GenerateBoardStructureParams = {
  workspaceId: string;
  description: string;
};

export type GenerateBoardStructureResponse = {
  boards: BoardTemplate[];
};

export const useBoardTemplateMutation = () => {
  return useMutation<GenerateBoardStructureResponse, unknown, GenerateBoardStructureParams>({
    mutationFn: async (params: GenerateBoardStructureParams) => {
      const response = await Workspaces.Templates.generate(params);

      if (!('boards' in response) || !Array.isArray(response.boards)) {
        throw new Error('Invalid response from AI generation');
      }

      return response;
    },

    onError: (error, { workspaceId, description }) => {
      reportErrorToBugsnag({
        error,
        context: 'Failed to generate AI board structure',
        metadata: { workspaceId, description },
      });
    },
  });
};
